var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnouncement03 = function SvgAnnouncement03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.964 6.27q.915.816 1.476 2.06.56 1.24.56 2.726t-.56 2.726q-.56 1.242-1.476 2.06zM2 12.61V9.501q0-.863.549-1.513l.169-.18a2.35 2.35 0 0 1 1.471-.697l.247-.01h6.397L17.809 3v16.111l-6.976-4.101H8.547V21H6.59v-5.99H4.436v-1.5h6.805l5.068 2.98V5.62l-5.068 2.98H4.436a.87.87 0 0 0-.665.276c-.2.196-.271.379-.271.625v3.107c0 .247.072.43.27.625.2.197.395.276.666.276v1.5l-.247-.011a2.3 2.3 0 0 1-1.288-.53l-.183-.166A2.3 2.3 0 0 1 2 12.609"
  })));
};
export default SvgAnnouncement03;